import React, { useMemo, useState } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { HeaderMenuWrapper } from "./header-menu/HeaderMenuWrapper";
import { AnimateLoading } from "../../../_partials/controls";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_helpers";
import { useHistory } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import Tooltip from '@material-ui/core/Tooltip';
import { Dialog, DialogTitle } from "@material-ui/core";


export function Header() {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses("header", true),
      headerAttributes: uiService.getAttributes("header"),
      headerContainerClasses: uiService.getClasses("header_container", true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        "header.menu.self.display"
      )
    };
  }, [uiService]);

  const user = useSelector(({ auth }) => auth.user, shallowEqual);

  const [openForm, setOpenForm] = useState(false);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenForm(false)
  };
  const history = useHistory();

  return (
    <>

      <Dialog open={openForm} onClose={handleClose} >
        <div className="p-5">
          <DialogTitle id="alert-dialog-title" className="text-center"><h1>Are you Sure ?</h1></DialogTitle>
          <div className="mx-auto mt-2 row form-group justify-content-sm-center">
            <button type="submit" onClick={() => setOpenForm(false)} className="col-sm-5 mr-1 btn btn-light-primary font-weight-bold" >Cancel</button>
            <button type="submit" onClick={() => history.push("/logout")} className="col-sm-5 ml-1 btn btn-light-danger font-weight-bold" >Logout</button>
          </div>
        </div>
      </Dialog>



      {/*begin::Header*/}
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        {/*begin::Container*/}
        <div className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-between`}>
          <AnimateLoading />
          {/*begin::Header Menu Wrapper*/}
          {layoutProps.menuHeaderDisplay && <HeaderMenuWrapper />}
          {!layoutProps.menuHeaderDisplay && <div />}
          {/*end::Header Menu Wrapper*/}

          {/*begin::Topbar*/}
          {/* <Topbar /> */}

          <div className="topbar-item ml-auto pt-1">
            <div className=" d-flex align-items-center btn-lg px-2" >
              <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">
                Hi,
                </span>
              <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
                {user ? (user.vFullName) : ("")}
              </span>
              {/* <Link to={ "/logout"}> */}
              <span onClick={() => setOpenForm(true)} className="btn btn-icon w-auto btn-clean pl-1 pr-1">
                <Tooltip title="Logout">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/Electric/Shutdown.svg")} />
                </Tooltip>
              </span>
              {/* </Link> */}
            </div>
          </div>
          {/*end::Topbar*/}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Header*/}
    </>
  );
}
